// src\components\popup\popupRegistry.js
export const popupRegistry = {
	feedbackMessage: () => import('@/components/popup/popups/feedbackMessage.vue'),
	sendMessage: () => import('@/components/popup/popups/sendMessage.vue'),
	// Добавить сюда новые попапы по мере необходимости
}
